import { CarrierLogo, DangerousHtmlContent } from '@eti/components';
import { css } from '@eti/styles';
import type { HeadingTypes } from '@etg/wings';
import { LinkButton } from '@etg/wings';
import TitledCard from '../components/TitledCard';

const carrierLogoStyles = css`
  height: 30px;
  width: auto;
`;

const titledCardDescriptionStyles = css`
  display: inline;
  margin-inline-end: 4px;
`;

interface CFCInfoCardProps {
  className: string;
  contentText: string;
  'data-testid'?: string;
  handleLinkButtonClick: () => void;
  headingLevel?: HeadingTypes['level'];
  linkButtonText: string;
  title: string;
}

const CFCInfoCard = ({
  className,
  contentText,
  'data-testid': dataTestId = 'cfc-info-card',
  handleLinkButtonClick,
  headingLevel = 3,
  linkButtonText,
  title,
}: CFCInfoCardProps) => {
  return (
    <TitledCard
      className={className}
      data-testid={dataTestId}
      headingLevel={headingLevel}
      icon={<CarrierLogo className={carrierLogoStyles} id="FR" imageAlt="Ryanair logo" />}
      title={title}
    >
      <DangerousHtmlContent className={titledCardDescriptionStyles} content={contentText} />
      <LinkButton onClick={handleLinkButtonClick}>{linkButtonText}</LinkButton>
    </TitledCard>
  );
};

export default CFCInfoCard;
